import React, { useContext } from "react";
import PropTypes from "prop-types";

import InvoiceSectionViewer from "./InvoiceTemplateViewer/InvoiceSectionViewer";
import CustomerSectionViewer from "./InvoiceTemplateViewer/CustomerSectionViewer";
import SellerSectionViewer from "./InvoiceTemplateViewer/SellerSectionViewer";
import InvoiceTableSectionViewer from "./InvoiceTemplateViewer/InvoiceTableSectionViewer";
import FooterSectionViewer from "./InvoiceTemplateViewer/FooterSectionViewer";
import SignatureSectionViewer from "./InvoiceTemplateViewer/SignatureSectionViewer";
import { InvoiceTemplateContext } from "./InvoiceTemplateContext";
import { viewerConfig } from "./const";

const styles = `
  *, *::before, *::after {
    box-sizing: border-box;
  }
  .text-center {
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
  .mt-1 {
    margin-top: 4px;
  }
  .mt-2 {
    margin-top: 8px;
  }
  .mt-3 {
    margin-top: 12px;
  }
  .invoice-template-wrapper {
    padding: 16px;
    position: relative;
    z-index: 4;
  }
  .invoice-template-container{
    position: relative;
    z-index: 4;
  }
  table {
    border-color: inherit;
    color: inherit;
    border-collapse: separate;
    text-indent: initial;
    border-spacing: 2px;
    caption-side: bottom;
    border-collapse: collapse;
  }
  table tr {
    border-width: 0;
  }
  table tr, span {
    color: inherit;
    border-color: inherit;
  }
  table td, table th {
    color: inherit;
    border-color: inherit;
    display: table-cell;
    vertical-align: inherit;
  }
  .invoice-section {
    padding-top: 8px;
    padding-bottom: 8px;
    position: relative;
  }
  .customer-section {
    border-top: solid 1px;
  }
  .seller-section {
  }
  .with-border-top {
    border-top: solid 1px;
  }
  .footer-section {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .footer-border {
    border-top: dashed 1px;
  }
  .frame-pattern-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  .background-image {
    position: absolute;
    z-index: 2;
  }
  .background-image-container,
  .watermark-image-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .watermark-image {
    position: absolute;
    z-index: 1;
  }
  .qr-code-container {
    width: 120px;
    text-align: center;
  }
  .logo-container {
    max-width: 220px;
    text-align: center;
  }

  .invoice-table-heading tr td{
    text-align: center;
  }

  .customer-table {

  }
  .customer-table-row {
    display: flex;
    flex-direction: row;
  }

  .customer-table-row .value-text {
    flex-grow: 1;
    margin-left: 4px;
  }
`;

const InvoiceTemplateViewer = ({ data }) => {
  const { dispatch } = useContext(InvoiceTemplateContext);

  const onWatermarkLoad = event => {
    dispatch({
      type: "extractWatermarkImageSize",
      payload: {
        width: event.target.clientWidth,
        height: event.target.clientHeight,
      },
    });
  };

  const containerStyle =
    data.frame.enabled && data.frame.type === "border"
      ? data.frame.border.style
      : {};

  return (
    <div style={{ width: `${viewerConfig.viewerWidth}px` }}>
      <style>{styles}</style>
      <div className="invoice-template-wrapper" style={data.style}>
        {data.frame.enabled && data.frame.type === "pattern" && (
          <img
            className="frame-pattern-image"
            style={data.frame.pattern.style}
            src={data.frame.pattern.url}
            alt="invoice border"
          />
        )}
        <div
          className="invoice-template-container"
          style={{
            ...containerStyle,
            height: viewerConfig.viewerHeight,
            padding: data.frame.padding ? `${data.frame.padding}px` : "0",
          }}
        >
          {data.background.enabled && (
            <div className="background-image-container">
              <img
                className="background-image"
                style={data.background.style}
                src={data.background.url}
                alt="invoice background"
              />
            </div>
          )}

          {data.viewPrioritize === "invoiceSection" ? (
            <>
              <div className="invoice-section invoice-section">
                <InvoiceSectionViewer invoiceData={data} />
              </div>

              <div className="invoice-section seller-section with-border-top">
                <SellerSectionViewer invoiceData={data} />
              </div>
            </>
          ) : (
            <>
              <div className="invoice-section seller-section">
                <SellerSectionViewer invoiceData={data} />
              </div>
              <div className="invoice-section invoice-section with-border-top">
                <InvoiceSectionViewer invoiceData={data} />
              </div>
            </>
          )}

          <div className="invoice-section customer-section">
            <CustomerSectionViewer invoiceData={data} />
          </div>

          <div className="invoice-section invoice-table-section">
            {data.watermark.enabled && (
              <div className="watermark-image-container">
                <img
                  onLoad={onWatermarkLoad}
                  className="watermark-image"
                  style={data.watermark.style}
                  src={
                    data.watermark.useLogo ? data.logo.url : data.watermark.url
                  }
                  alt="invoice watermark"
                />
              </div>
            )}
            <InvoiceTableSectionViewer invoiceData={data} />
          </div>

          <div className="invoice-section signature-section">
            <SignatureSectionViewer invoiceData={data} />
          </div>
          <div className="invoice-section footer-section">
            <div className="text-center">
              (Cần kiểm tra đối chiếu khi lập, giao, nhận hóa đơn)
            </div>
            <div className="footer-border">
              <FooterSectionViewer invoiceData={data} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

InvoiceTemplateViewer.propTypes = {
  data: PropTypes.object,
};

export default InvoiceTemplateViewer;
